import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { Link } from 'react-router';
import Modal from 'react-modal';
import * as DocumentStorageActions from '../actions/documentStorage';
import { FormattedMessage, FormattedDate, FormattedTime, injectIntl } from 'react-intl';
import objectPath from 'object-path';
import ConfirmModal from './ConfirmModal.react';
import ConfiguratorManager from '../ConfiguratorManager';
import * as ConfiguratorActions from '../actions/configurator';
import * as CartActions from '../actions/cart';

class DashboardList extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            modalOpenBy: false,
            modalIsOpen: false,
            modalFormValueDocumentStorageId: null,
            modalFormValueTitle: null,
            modalFormValueLocale: null,
            modalFormError: false,
            modalFormErrorTitle: false,
            modalFormErrorLocale: false,
            modalFormOptionLocales: [],
            search: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleModalCloseRequest = this.handleModalCloseRequest.bind(this);
        this.handleSaveClicked = this.handleSaveClicked.bind(this);
        this.addToCart = this.addToCart.bind(this);
    };

    openModal(storageId, documentId) {

        const { dispatch } = this.props;

        dispatch(ConfiguratorActions.getConfiguratorDataByDocument(documentId));

        this.setState({modalOpenBy: {storageId: storageId, documentId: documentId}});
    }

    closeModal() {
        this.setState({modalIsOpen: false, modalOpenBy: false});
    }

    handleModalCloseRequest() {
        this.setState({modalIsOpen: false, modalOpenBy: false});
    }

    handleSaveClicked(event) {

        event.preventDefault();

        const formData = {
            title: ReactDOM.findDOMNode(this.refs.title).value,
            locale: ReactDOM.findDOMNode(this.refs.locale).value
        };

        let error = false;
        let newState = {
            ...this.state,
            modalFormError: false,
            modalFormErrorTitle: false,
            modalFormErrorLocale: false
        };

        if (!formData.title) {
            error = true;
            newState = {
                ...newState,
                modalFormError: true,
                modalFormErrorTitle: true,
            }
        }
        if (!formData.locale) {
            error = true;
            newState = {
                ...newState,
                modalFormError: true,
                modalFormErrorLocale: true
            }
        }

        this.setState(newState, function () {
            if (error === false) {
                this.closeModal();
                let {dispatch} = this.props;

                dispatch(
                    DocumentStorageActions.copyDocumentStorage(this.state.modalFormValueDocumentStorageId, formData.title, formData.locale, true)
                );
            }
        });
    }

    deleteStorage(storageId) {

        let { dispatch } = this.props;
        let data = {
            title: this.props.intl.formatMessage({id: 'LABEL_DELETE_DOCUMENT_STORAGE'}).toString(),
            msg: this.props.intl.formatMessage({id: 'CONFIRM_DELETE_DOCUMENT_STORAGE'}).toString(),
            cancelMsg: this.props.intl.formatMessage({id: 'LABEL_CANCEL'}).toString(),
            callback: () => dispatch(DocumentStorageActions.deleteDocumentStorage(storageId))
        };

        ReactDOM.render(<ConfirmModal openModal={true} data={data}/>, document.getElementById('confirm-modal-overlay'));
    }

    addToCart(documentStorageId) {
        const {dispatch} = this.props;
        dispatch(CartActions.updateItem(documentStorageId, 1));
    }

    componentDidUpdate(prevProps, prevState) {

        const { configurator, documentStorage } = this.props;

        if (configurator && configurator.loading === false && this.state.modalOpenBy !== false && this.state.modalIsOpen === false) {

            const CM = new ConfiguratorManager(
                configurator,
                documentStorage,
                this.state.modalOpenBy.documentId,
                this.state.modalOpenBy.storageId,
                0
            );

            let locales = [];
            let localeValue = null;
            CM.getDocumentEnabledLocales().map(locale => {
                locales.push(
                    { "id": locale, "label": "LANGUAGE_" + locale }
                )
            });

            if (locales.length === 1) {
                localeValue = locales[0].id;
            }

            let oldState = this.state;

            let newState = {
                ...oldState,
                modalFormValueDocumentStorageId: this.state.modalOpenBy.storageId,
                modalIsOpen: true,
                modalFormValueTitle: null,
                modalFormValueLocale: localeValue,
                modalFormError: false,
                modalFormErrorTitle: false,
                modalFormErrorLocale: false,
                modalFormOptionLocales: locales,
            };

            this.setState(newState);
        }

    }

    handleSearch(event) {
        event.preventDefault();
        this.setState({
            search: event.target.value,
        })
    }

    render() {

        const { documentStorage } = this.props;
        const intl = this.props.intl;
        const currentLocale = intl.locale.replace('-', '_'); // de-DE -> de_DE

        const classNameTitle = this.state.modalFormErrorTitle ? 'form-group has-error' : 'form-group';
        const classNameLocale = this.state.modalFormErrorLocale ? 'form-group has-error' : 'form-group';

        const searchString = this.state.search.toLowerCase();
        const filteredDocumentStorage = documentStorage.data.filter(function (item) {
            return (
                searchString === '' ||
                item.author.toLowerCase().indexOf(searchString) >= 0 ||
                item.campaign.toLowerCase().indexOf(searchString) >= 0 ||
                item.documentName.toLowerCase().indexOf(searchString) >= 0 ||
                item.organization.toLowerCase().indexOf(searchString) >= 0
            )
        });

        return (
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h4 className="panel-title">
                            <FormattedMessage id="LABEL_DOCUMENTS_OVERVIEW"/>
                        </h4>
                    </div>
                    <div className="panel-body table-responsive">
                        <FormattedMessage id="LABEL_SEARCH_DOCUMENTS">
                            {(message) => (
                                <div id="document-search-instances" className="input-group">
                                    <div className="input-group-addon"><FormattedMessage id="LABEL_SEARCH_ADDON" /></div>
                                    <input type="text" className="form-control" placeholder={message} value={this.state.search} onChange={this.handleSearch.bind(this)}/>
                                </div>
                            )}
                        </FormattedMessage>
                        <table className="table table-sm table-striped table-hover shadow">
                            <thead>
                            <tr>
                                <th><FormattedMessage id="LABEL_TITLE"/></th>
                                <th><FormattedMessage id="LABEL_CAMPAIGN"/> (<FormattedMessage id="LABEL_DOCUMENT"/>)</th>
                                <th></th>
                                <th><FormattedMessage id="LABEL_LANGUAGE"/></th>
                                <th><FormattedMessage id="LABEL_AUTHOR"/></th>
                                <th><FormattedMessage id="LABEL_CREATED_AT"/></th>
                                <th><FormattedMessage id="LABEL_UPDATED_AT"/></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                            {
                                filteredDocumentStorage.map((storage, i) => {

                                    const pdfLink = '/api/pdfproduct/send-zip/' + storage.id + '?webquality=0&printmarks=1';
                                    const pdfLinkWebVersion = '/api/pdfproduct/send/' + storage.id + '?webquality=1&printmarks=1';
                                    const configuratorRoute = '/configurator/' + storage.documentId + '/' + storage.id + '/0';
                                    const localeLabel = 'LANGUAGE_' + storage.locale;

                                    const isApproval = storage.documentApprovalProcess;

                                    let campaignTitle = objectPath.get(storage, 'translationsSorted.' + currentLocale + '.campaign');
                                    if (!campaignTitle) {
                                        campaignTitle = storage.campaign;
                                    }
                                    let documentTitle = objectPath.get(storage, 'translationsSorted.' + currentLocale + '.documentName');
                                    if (!documentTitle) {
                                        documentTitle = storage.documentName;
                                    }

                                    let transButton = '';
                                    if (storage.documentId===122 || storage.documentId===124 || storage.documentId===227 || storage.documentId===226) {

                                        transButton = <a role="button" className="btn btn-success" target="_blank"  onClick={() => { this.openModal(storage.id, storage.documentId) }}>
                                            <FormattedMessage id="LABEL_TRANSLATE_VERSION" />
                                        </a>
                                    }

                                    let actionIconPdf = <FormattedMessage id="LABEL_PDF">
                                        {(message) => (
                                            <a href={pdfLink} target="_blank">
                                                <i className="material-icons" title={ message }>picture_as_pdf</i>
                                            </a>
                                        )}
                                    </FormattedMessage>;
                                    let actionIconDownload = <FormattedMessage id="LABEL_WEBVERSION_DOWNLOAD">
                                        {(message) => (
                                            <a href={pdfLinkWebVersion} target="_blank">
                                                <i className="material-icons"
                                                   title={ message }>visibility</i>
                                            </a>
                                        )}
                                    </FormattedMessage>;
                                    let actionIconAddCart = <FormattedMessage id="LABEL_CART_ADD">
                                        {(message) => (
                                            <a onClick={() => { this.addToCart(storage.id) }}>
                                                <i className="material-icons" data-tip={ message }>add_shopping_cart</i>
                                            </a>
                                        )}
                                    </FormattedMessage>;
                                    let inApprovalButton = '';

                                    if (isApproval) {
                                        actionIconPdf = '';
                                        actionIconDownload = '';
                                        actionIconAddCart = '';
                                        inApprovalButton =  <span className="btn btn-success">
                                                <FormattedMessage id="LABEL_WAIT_APPROVAL" />
                                            </span>;

                                        if (storage.approvalRequested) {
                                            inApprovalButton =  <span className="btn btn-success">
                                                <FormattedMessage id="LABEL_IN_APPROVAL" />
                                            </span>;
                                        }

                                        if (storage.approvalProcessApproved) {

                                            const approvedPdfLink = '/api/pdfproduct/send-zip-approved/' + storage.id + '/' + storage.approvalProcessApproveHash + '?webquality=0&printmarks=1';
                                            const approvedPdfLinkWebVersion = '/api/pdfproduct/send-approved-pdf/' + storage.id + '/' + storage.approvalProcessApproveHash + '?webquality=1&printmarks=1';

                                            inApprovalButton =  <span className="btn btn-success">
                                                <FormattedMessage id="LABEL_IN_APPROVED" />
                                            </span>;

                                            actionIconPdf = <FormattedMessage id="LABEL_PDF">
                                                {(message) => (
                                                    <a href={approvedPdfLink} target="_blank">
                                                        <i className="material-icons" title={ message }>picture_as_pdf</i>
                                                    </a>
                                                )}
                                            </FormattedMessage>;

                                            actionIconDownload = <FormattedMessage id="LABEL_WEBVERSION_DOWNLOAD">
                                                {(message) => (
                                                    <a href={approvedPdfLinkWebVersion} target="_blank">
                                                        <i className="material-icons"
                                                           title={ message }>visibility</i>
                                                    </a>
                                                )}
                                            </FormattedMessage>;

                                        }
                                    }

                                    const disabled = {
                                        color: 'white',
                                        backgroundColor: '#db0b1c',
                                        pointerEvents: 'none'
                                    };

                                    let style;
                                    let availability;

                                    if(!storage.documentActive){
                                        style=disabled;
                                        availability=<FormattedMessage id="LABEL_AVAILABILITY" />
                                    }else{
                                        style=null;
                                        availability='';
                                    }

                                    return <tr key={i}  style={style}>
                                        <td><Link to={configuratorRoute}  className="text-bold">{storage.title} {availability}</Link></td>
                                        <td><span className="text-bold">{campaignTitle}</span> <span className="text-italic">({documentTitle})</span></td>
                                        <td>
                                            {transButton}
                                            {inApprovalButton}
                                        </td>
                                        <td><FormattedMessage id={localeLabel}/></td>
                                        <td>{storage.author}</td>
                                        <td><FormattedDate value={storage.createdAt} /> </td>
                                        <td><FormattedDate value={storage.updatedAt} /> </td>
                                        <td>
                                            <FormattedMessage id="LABEL_EDIT">
                                                {(message) => (
                                                    <Link to={configuratorRoute}>
                                                        <i className="material-icons" title={ message }>create</i>
                                                    </Link>
                                                )}
                                            </FormattedMessage>
                                        </td>
                                        <td>
                                            {actionIconPdf}
                                        </td>
                                        <td>
                                            {actionIconDownload}
                                        </td>
                                        <td>
                                            <FormattedMessage id="LABEL_COPY">
                                                {(message) => (
                                                    <a onClick={() => { this.openModal(storage.id, storage.documentId) }}>
                                                        <i className="material-icons" title={ message }>note_add</i>
                                                    </a>
                                                )}
                                            </FormattedMessage>
                                        </td>
                                        <td>
                                            <FormattedMessage id="LABEL_DELETE_DOCUMENT_STORAGE">
                                                {(message) => (
                                                    <a onClick={()=>{this.deleteStorage(storage.id) }}>
                                                        <i className="material-icons" title={ message }>delete_forever</i>
                                                    </a>
                                                )}
                                            </FormattedMessage>
                                        </td>
                                        <td>
                                            {actionIconAddCart}
                                        </td>
                                    </tr>
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                    <div id="confirm-modal-overlay"></div>
                </div>
                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.handleModalCloseRequest}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.handleModalCloseRequest}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                            </button>
                            <h4 className="modal-title"><FormattedMessage id="LABEL_COPY_STORAGE"/></h4>
                        </div>

                        <div className="modal-body">
                            <form className="form-horizontal" role="form"
                                  onSubmit={event => this.handleSaveClicked(event)}>

                                <div className={classNameTitle}>
                                    <label className="control-label col-sm-2" for="title"><FormattedMessage
                                        id="LABEL_DOCUMENT"/></label>
                                    <div className="col-sm-10">
                                        <input type="text" className="form-control" id="title"
                                               defaultValue={this.state.modalFormValueTitle} ref="title"/>
                                    </div>
                                </div>

                                <div className={classNameLocale}>
                                    <label className="control-label col-sm-2" for="locale"><FormattedMessage
                                        id="LABEL_LANGUAGE"/></label>
                                    <div className="col-sm-10">
                                        <select className="form-control" id="locale"
                                                defaultValue={this.state.modalFormValueLocale} ref="locale">
                                            <FormattedMessage id="LABEL_SELECT_LANGUAGE">
                                                {(message) => (
                                                    <option value="">-- {message} --</option>
                                                )}
                                            </FormattedMessage>
                                            {
                                                this.state.modalFormOptionLocales.map((locale, i) => {
                                                    return <FormattedMessage id={locale.label} key={i}>
                                                        {(message) => (
                                                            <option value={locale.id} key={i}>{message}</option>
                                                        )}
                                                    </FormattedMessage>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                            </form>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default"
                                    onClick={this.handleModalCloseRequest}>
                                <FormattedMessage id="LABEL_CANCEL"/></button>
                            <button type="button" className="btn btn-primary"
                                    onClick={event => this.handleSaveClicked(event)}><FormattedMessage
                                id="LABEL_TO_CONFIGURATOR"/></button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default connect(state => ({ documentStorage: state.documentStorage, app: state.app, configurator: state.configurator }))(injectIntl(DashboardList));



// WEBPACK FOOTER //
// ./src/js/components/DashboardList.react.jsx